import { createSlice } from '@reduxjs/toolkit'

const Head =  createSlice({
    name: 'head',
    initialState:{
        Title:'Home',
        updateLogo:false
        },
    reducers:{
        setTitle(state , action){
            state.Title = action.payload
            console.log('action' ,action)
            console.log('state' ,state)
        },
        setUpdateLogo(state , action){
            state.updateLogo = action.payload
            console.log('action' ,action)
            console.log('state' ,state)
        },
    }
 
})
export const { setTitle,setUpdateLogo } = Head.actions
export default Head.reducer